import { useContext } from 'react';

import Context from '../../Context';

const ContainerComponent = ({ children }) => {
  const { isLoading, total, classNames } = useContext(Context);

  return children({ total, isLoading, classNames });
};

ContainerComponent.displayName = 'LineItem-Total-container';

export default ContainerComponent;
